// extracted by mini-css-extract-plugin
export default {"statusContainer":"StudentStatusLabel_statusContainer__pUZIj","status":"StudentStatusLabel_status__pAEsQ"};